import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {analyticsClient} from '../../../analytics-client';
import {appHistory} from '../../../history';

import {useOpenableModal, OpenableModals} from '../../openable-modals';

import {Introduction, Explanation, Identify, Sense, Source, Reports} from './pages';

export function AnalyticsOnboardingModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.ANALYTICS_ONBOARDING_MODAL);

    const onFinish = () => {
        onClose();
        appHistory.push('/email-marketing/analytics');
    };

    // Update when the reports are done!
    const reportingIsImplemented = false;

    const pages = [
        {
            id: 'Learn',
            body: <Introduction />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='analytics-info' />} width={210} />
                ),
            },
        },
        {
            id: 'Explanation',
            body: <Explanation />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='code-snippet' />} width={270} />
                ),
            },
        },
        {
            id: 'Identify',
            body: <Identify />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='site-visitors' />} width={210} />
                ),
            },
        },
        {
            id: 'Source',
            body: <Source />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='assign-sources' />} width={140} />
                ),
            },
        },
        {
            id: 'Sense',
            body: <Sense />,
            art: {
                background: colors.plumLt,
                image: () => <ImageWrapper image={<Illustration src='reporting' />} width={210} />,
            },
        },
    ];

    if (reportingIsImplemented) {
        pages.push({
            id: 'Reports',
            body: <Reports />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='analytics-data' />} width={220} />
                ),
            },
        });
    }

    return isOpen ? (
        <OnboardingModal
            trapFocus={false}
            lastButtonText='Check it out'
            pages={pages}
            onClose={onClose}
            onFinish={onFinish}
            canClickOutsideToClose={false}
            analyticsClient={analyticsClient}
            getAnalyticsEventForPageView={getAnalyticsEventForPageView}
        />
    ) : (
        <></>
    );
}

const getAnalyticsEventForPageView = (pageNumber: number) => {
    switch (pageNumber) {
        case 0:
            return analyticsClient.EVENTS.TRACK_SOURCES_ONBOARDING_STARTED;
        case 4:
            return analyticsClient.EVENTS.TRACK_SOURCES_ONBOARDING_COMPLETED;
        default:
            return null;
    }
};
